<template>
  <router-view></router-view>
</template>

<script setup lang="ts">
</script>

<style>
#app {
  font-family: 'Noto Sans HK', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
}

* {
  box-sizing: border-box;
}
</style>
